document.addEventListener('DOMContentLoaded', () => {
  initDrawers();
  initDesktopNavDropdowns();
  initHeader();
  initTicker();
  initStaggerGrids();
  initReveal();
  initProductGallery();
  initSwatchColors();
  initProductOptions();
  initStickyAtc();
  initSizeGuide();
  initPredictiveSearch();
  initAjaxCart();
});

const reduced = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;

function initDrawers() {
  const nav = document.querySelector('[data-nav-drawer]');
  const navBtn = document.querySelector('[data-nav-toggle]');
  const cart = document.querySelector('[data-cart-drawer]');
  const header = document.querySelector('.ar-header');

  const closeNav = () => {
    nav?.classList.remove('is-open');
    nav?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('nav-open');
    navBtn?.setAttribute('aria-expanded', 'false');
    closeAllSubmenus();
  };

  function openNav() {
    header?.classList.remove('is-hidden');
    nav?.classList.add('is-open');
    nav?.setAttribute('aria-hidden', 'false');
    document.body.classList.add('nav-open');
    navBtn?.setAttribute('aria-expanded', 'true');
    cart?.classList.remove('is-open');
    document.body.classList.remove('cart-open');
  }

  navBtn?.addEventListener('click', () => {
    nav?.classList.contains('is-open') ? closeNav() : openNav();
  });
  nav?.querySelectorAll('[data-nav-close]').forEach((el) => el.addEventListener('click', closeNav));
  nav?.querySelectorAll('.ar-drawer__links a').forEach((a) => a.addEventListener('click', closeNav));

  initNavSubmenus(nav);

  document.querySelectorAll('[data-cart-toggle]').forEach((btn) => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      closeNav();
      cart?.classList.add('is-open');
      cart?.setAttribute('aria-hidden', 'false');
      document.body.classList.add('cart-open');
      refreshCart();
    });
  });

  const closeCart = () => {
    cart?.classList.remove('is-open');
    cart?.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  };

  cart?.querySelectorAll('[data-cart-close]').forEach((el) => el.addEventListener('click', closeCart));

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    closeNav();
    closeCart();
  });

  document.addEventListener('click', (e) => {
    if (!e.target.closest('[data-nav-parent]')) {
      document.querySelectorAll('[data-nav-dropdown-toggle]').forEach((btn) => {
        btn.setAttribute('aria-expanded', 'false');
        const item = btn.closest('[data-nav-parent]');
        item?.classList.remove('ar-nav__item--open', 'is-hover');
      });
    }
  });
}

function closeAllSubmenus() {
  document.querySelectorAll('[data-nav-submenu]').forEach((panel) => {
    panel.hidden = true;
  });
  document.querySelectorAll('[data-nav-submenu-toggle]').forEach((btn) => {
    btn.setAttribute('aria-expanded', 'false');
  });
}

function initNavSubmenus(navRoot) {
  navRoot?.querySelectorAll('[data-nav-submenu-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const panel = btn.nextElementSibling;
      if (!panel) return;
      const willOpen = panel.hidden;
      panel.hidden = !willOpen;
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });
}

function initDesktopNavDropdowns() {
  const items = document.querySelectorAll('.ar-header__nav [data-nav-parent]');
  if (!items.length) return;

  const canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  items.forEach((item) => {
    const btn = item.querySelector('[data-nav-dropdown-toggle]');
    let closeTimer;

    const openItem = () => {
      clearTimeout(closeTimer);
      items.forEach((other) => {
        if (other === item) return;
        other.classList.remove('ar-nav__item--open', 'is-hover');
        other.querySelector('[data-nav-dropdown-toggle]')?.setAttribute('aria-expanded', 'false');
      });
      item.classList.add('ar-nav__item--open', 'is-hover');
      btn?.setAttribute('aria-expanded', 'true');
    };

    const scheduleClose = () => {
      closeTimer = window.setTimeout(() => {
        item.classList.remove('ar-nav__item--open', 'is-hover');
        btn?.setAttribute('aria-expanded', 'false');
      }, 180);
    };

    if (canHover) {
      item.addEventListener('mouseenter', openItem);
      item.addEventListener('mouseleave', scheduleClose);
    }

    btn?.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (item.classList.contains('ar-nav__item--open')) {
        clearTimeout(closeTimer);
        item.classList.remove('ar-nav__item--open', 'is-hover');
        btn.setAttribute('aria-expanded', 'false');
      } else {
        openItem();
      }
    });

    item.addEventListener('focusin', openItem);
    item.addEventListener('focusout', (e) => {
      if (!item.contains(e.relatedTarget)) scheduleClose();
    });
  });
}

function initHeader() {
  const header = document.querySelector('.ar-header');
  if (!header) return;
  const onScroll = () => {
    if (document.body.classList.contains('nav-open') || document.body.classList.contains('cart-open')) {
      header.classList.remove('is-hidden');
      return;
    }
    const y = window.scrollY;
    header.classList.toggle('is-scrolled', y > 24);
    header.classList.remove('is-hidden');
  };
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
}

function initTicker() {
  document.querySelectorAll('.ar-ticker').forEach((el) => {
    const track = el.querySelector('.ar-ticker__track');
    if (!track) return;
    el.addEventListener('mouseenter', () => track.classList.add('is-paused'));
    el.addEventListener('mouseleave', () => track.classList.remove('is-paused'));
  });
}

function initReveal() {
  const els = document.querySelectorAll('[data-reveal]');
  if (!els.length || reduced()) {
    els.forEach((el) => el.classList.add('is-visible'));
    return;
  }
  const io = new IntersectionObserver(
    (entries) => {
      entries.forEach((e) => {
        if (!e.isIntersecting) return;
        e.target.classList.add('is-visible');
        io.unobserve(e.target);
      });
    },
    { threshold: 0.01, rootMargin: '0px 0px 12% 0px' }
  );
  els.forEach((el) => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight * 1.05 && rect.bottom > -40) {
      el.classList.add('is-visible');
      return;
    }
    io.observe(el);
  });
  // Mobile Safari / late layout: never leave content invisible
  window.setTimeout(() => {
    document.querySelectorAll('[data-reveal]:not(.is-visible)').forEach((el) => {
      el.classList.add('is-visible');
    });
  }, 2200);
}

function initStaggerGrids() {
  document.querySelectorAll('.ar-drop__grid, .ar-grid, .ar-footer__grid').forEach((grid) => {
    [...grid.children].forEach((child, i) => {
      if (!child.hasAttribute('data-reveal') && !child.classList.contains('ar-card')) return;
      if (!child.hasAttribute('data-reveal')) child.setAttribute('data-reveal', '');
      child.style.setProperty('--reveal-delay', `${Math.min(i * 70, 420)}ms`);
    });
  });
}

function initSwatchColors() {
  document.querySelectorAll('.ar-pdp__swatch.is-auto').forEach((el) => {
    const name = el.dataset.swatchName || '';
    const color = colorFromName(name);
    el.style.setProperty('--swatch-bg', color);
    if (isLightColor(color)) el.classList.add('is-light');
  });
}

function colorFromName(name) {
  const str = (name || '').toLowerCase().trim();
  if (/black|nero|obsidian|ink|onyx/.test(str)) return '#141414';
  if (/white|bianco|ivory|cream/.test(str)) return '#f4f4f0';
  if (/denim\/black|denim-black/.test(str)) return '#121820';
  if (/denim\/gray|denim\/grey|denim-gray|denim-grey|gray|grey|grigio/.test(str)) return '#6e7580';
  if (/denim|navy|indigo|blu|blue/.test(str)) return '#1a2744';
  if (/red|rosso|crimson/.test(str)) return '#c41e1e';
  if (/green|verde|olive/.test(str)) return '#3d5c3a';
  if (/beige|camel|sand|khaki/.test(str)) return '#c4a574';
  if (/brown|marrone|coffee/.test(str)) return '#5c4033';

  let hash = 0;
  for (let i = 0; i < str.length; i += 1) hash = str.charCodeAt(i) + ((hash << 5) - hash);
  const hue = Math.abs(hash) % 360;
  const sat = 28 + (Math.abs(hash >> 8) % 28);
  const light = 32 + (Math.abs(hash >> 16) % 22);
  return `hsl(${hue}, ${sat}%, ${light}%)`;
}

function isLightColor(color) {
  if (color.startsWith('#')) {
    const hex = color.replace('#', '');
    const full = hex.length === 3 ? hex.split('').map((c) => c + c).join('') : hex;
    const r = parseInt(full.slice(0, 2), 16);
    const g = parseInt(full.slice(2, 4), 16);
    const b = parseInt(full.slice(4, 6), 16);
    return (r * 299 + g * 587 + b * 114) / 1000 > 180;
  }
  if (!color.startsWith('hsl')) return false;
  const match = color.match(/hsl\([^,]+,[^,]+,\s*([0-9.]+)%/);
  return match ? Number(match[1]) > 62 : false;
}

function normalizeImageUrl(url) {
  if (!url) return '';
  try {
    return new URL(url, window.location.origin).pathname;
  } catch {
    return url.split('?')[0];
  }
}

function initProductGallery() {
  const gallery = document.querySelector('[data-pdp-gallery]');
  const main = document.querySelector('[data-pdp-main]');
  if (!gallery || !main) return;

  const mainImg = document.getElementById('ProductMainImage') || main.querySelector('.ar-pdp__main-img') || main.querySelector('img');
  const counter = gallery.querySelector('[data-pdp-counter]');
  const thumbsRail = gallery.querySelector('[data-pdp-thumbs]');
  let currentIndex = 0;

  const visibleThumbs = () =>
    [...gallery.querySelectorAll('[data-pdp-thumb]')].filter((t) => !t.classList.contains('is-filtered-out'));

  const updateMainImage = (src) => {
    if (!mainImg || !src) return false;
    mainImg.removeAttribute('srcset');
    mainImg.removeAttribute('sizes');
    mainImg.src = src;
    return true;
  };

  const setActive = (index, { updateMain = true } = {}) => {
    const vis = visibleThumbs();
    if (!vis.length) return false;
    currentIndex = ((index % vis.length) + vis.length) % vis.length;
    const thumb = vis[currentIndex];
    const src = thumb.dataset.full;
    if (updateMain) updateMainImage(src);
    gallery.querySelectorAll('[data-pdp-thumb]').forEach((t) => t.classList.remove('is-active'));
    thumb.classList.add('is-active');
    if (counter) counter.textContent = `${currentIndex + 1} / ${vis.length}`;
    thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    return true;
  };

  gallery.querySelector('[data-pdp-prev]')?.addEventListener('click', () => setActive(currentIndex - 1));
  gallery.querySelector('[data-pdp-next]')?.addEventListener('click', () => setActive(currentIndex + 1));

  gallery.querySelector('[data-pdp-thumbs-prev]')?.addEventListener('click', () => setActive(currentIndex - 1));
  gallery.querySelector('[data-pdp-thumbs-next]')?.addEventListener('click', () => setActive(currentIndex + 1));

  thumbsRail?.addEventListener('click', (e) => {
    const thumb = e.target.closest('[data-pdp-thumb]');
    if (!thumb || thumb.classList.contains('is-filtered-out')) return;
    const vis = visibleThumbs();
    const idx = vis.indexOf(thumb);
    if (idx >= 0) setActive(idx);
  });

  let scrollTimer;
  thumbsRail?.addEventListener(
    'scroll',
    () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const vis = visibleThumbs();
        if (!vis.length || !thumbsRail) return;
        const railRect = thumbsRail.getBoundingClientRect();
        const center = railRect.left + railRect.width / 2;
        let bestIdx = 0;
        let minDist = Infinity;
        vis.forEach((thumb, i) => {
          const rect = thumb.getBoundingClientRect();
          const dist = Math.abs(rect.left + rect.width / 2 - center);
          if (dist < minDist) {
            minDist = dist;
            bestIdx = i;
          }
        });
        if (bestIdx !== currentIndex) setActive(bestIdx);
      }, 100);
    },
    { passive: true }
  );

  let touchStartX = 0;
  main.addEventListener(
    'touchstart',
    (e) => {
      touchStartX = e.changedTouches[0]?.clientX || 0;
    },
    { passive: true }
  );
  main.addEventListener(
    'touchend',
    (e) => {
      const dx = (e.changedTouches[0]?.clientX || 0) - touchStartX;
      if (Math.abs(dx) < 40) return;
      setActive(dx < 0 ? currentIndex + 1 : currentIndex - 1);
    },
    { passive: true }
  );

  const normColor = (value) => (value || '').trim().toLowerCase();

  gallery.filterByColor = (colorValue, { resetIndex = false } = {}) => {
    if (!colorValue) return;
    const target = normColor(colorValue);
    gallery.querySelectorAll('[data-pdp-thumb]').forEach((thumb) => {
      const colors = thumb.dataset.colors || 'all';
      const list = colors === 'all' ? ['all'] : colors.split(',').map((c) => c.trim()).filter(Boolean);
      const show = list.some((c) => normColor(c) === 'all' || normColor(c) === target);
      thumb.classList.toggle('is-filtered-out', !show);
    });
    if (resetIndex) setActive(0);
  };

  gallery.showMedia = (mediaId) => {
    if (!mediaId) return false;
    const thumb = gallery.querySelector(`[data-pdp-thumb][data-media-id="${mediaId}"]`);
    if (!thumb || thumb.classList.contains('is-filtered-out')) return false;
    const idx = visibleThumbs().indexOf(thumb);
    if (idx >= 0) return setActive(idx);
    return false;
  };

  gallery.showImage = (src) => {
    if (!src) return false;
    const target = normalizeImageUrl(src);
    const thumb = visibleThumbs().find((t) => normalizeImageUrl(t.dataset.full) === target);
    if (thumb) {
      const idx = visibleThumbs().indexOf(thumb);
      if (idx >= 0) return setActive(idx);
    }
    gallery.querySelectorAll('[data-pdp-thumb]').forEach((t) => t.classList.remove('is-active'));
    return updateMainImage(src);
  };

  gallery.showVariant = (variant) => {
    if (!variant) return;
    const mediaId = variant.featured_media?.id || variant.featured_media_id;
    const src = variant.featured_media?.preview_image?.src || variant.featured_image?.src || variant.image;
    if (mediaId && gallery.showMedia(String(mediaId))) return;
    if (src) gallery.showImage(src);
  };

  setActive(0);
}

function initProductOptions() {
  const form = document.querySelector('[data-pdp-form]');
  const jsonEl = document.getElementById('product-variants-json');
  if (!form || !jsonEl) return;

  let variants;
  try {
    variants = JSON.parse(jsonEl.textContent);
  } catch {
    return;
  }

  const optionsJson = document.getElementById('product-options-json');
  const optionNames = optionsJson ? JSON.parse(optionsJson.textContent) : [];
  const idInput = form.querySelector('[data-variant-input]') || form.querySelector('[name="id"]');
  const priceEl = document.querySelector('[data-pdp-price]');
  const metaEl = document.querySelector('[data-pdp-meta]');
  const atcBtn = form.querySelector('[data-atc-btn]') || form.querySelector('[type="submit"]');
  const sticky = document.querySelector('[data-sticky-submit]');
  const stickyLabel = atcBtn?.dataset.label || sticky?.dataset.label || 'Aggiungi al carrello';
  const metaAvailable = metaEl?.dataset.available || 'Disponibile — spedizione rapida';
  const metaUnavailable = metaEl?.dataset.unavailable || 'Esaurito — torna presto';
  const metaSuffix = metaEl?.dataset.suffix || '';
  let stickyPriceText = '';

  const selected = {};
  document.querySelectorAll('[data-option-selected]').forEach((el) => {
    selected[el.dataset.optionSelected] = el.textContent.trim();
  });

  const optionsRoot = document.querySelector('[data-product-options]');
  const explicitVariantId = optionsRoot?.dataset.explicitVariant || '';
  const sizeRow = document.querySelector('[data-option-kind="size"]');
  const sizeRequired = Boolean(sizeRow?.hasAttribute('data-require-choice'));
  const sizeKey = sizeRow?.querySelector('[data-option-value]')?.dataset.optionKey || '';
  if (sizeRequired && sizeRow && !explicitVariantId) {
    sizeRow.querySelectorAll('[data-option-value]').forEach((btn) => {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-selected', 'false');
    });
    const sizeLabel = sizeRow.querySelector('[data-option-selected]');
    if (sizeLabel) {
      sizeLabel.textContent = '';
      selected[sizeLabel.dataset.optionSelected] = '';
    }
    if (idInput) idInput.value = '';
  }
  const chooseSizeLabel = atcBtn?.dataset.chooseLabel || sticky?.dataset.chooseLabel || 'Scegli la taglia';
  const soldLabel = atcBtn?.dataset.soldLabel || sticky?.dataset.soldLabel || 'Esaurito';

  const sizeChosen = () => {
    if (!sizeRequired || !sizeRow) return true;
    return Boolean(sizeRow.querySelector('[data-option-value].is-selected'));
  };

  const handleize = (str) =>
    str
      .toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '');

  function findVariant(opts) {
    return variants.find((v) =>
      optionNames.every((name, i) => {
        const key = handleize(name);
        const val = [v.option1, v.option2, v.option3][i];
        return !opts[key] || val === opts[key];
      })
    );
  }

  function setMeta(available) {
    if (!metaEl) return;
    const lead = available ? metaAvailable : metaUnavailable;
    metaEl.textContent = metaSuffix ? `${lead} · ${metaSuffix}` : lead;
  }

  function updatePrice(variant) {
    const current = priceEl?.querySelector('[data-pdp-price-current]');
    const compare = priceEl?.querySelector('[data-pdp-price-compare]');
    const amount = formatMoney(variant.price);
    if (current) current.textContent = amount;
    else if (priceEl) priceEl.textContent = amount;
    const stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = amount;
    if (compare) {
      const compareAt = variant.compare_at_price;
      if (compareAt && compareAt > variant.price) {
        compare.hidden = false;
        compare.textContent = formatMoney(compareAt);
      } else {
        compare.hidden = true;
        compare.textContent = '';
      }
    }
  }

  function updateStickySize() {
    const sizeEl = document.querySelector('[data-sticky-size]');
    if (!sizeEl || !sizeRow) return;
    const picked = sizeRow.querySelector('[data-option-value].is-selected');
    sizeEl.textContent = picked ? picked.dataset.optionValue : '';
  }

  function syncStickyLabel(variant) {
    if (!sticky) return;
    updateStickySize();
    if (!sizeChosen()) {
      sticky.dataset.mode = 'choose';
      sticky.textContent = chooseSizeLabel;
      sticky.disabled = false;
      return;
    }
    if (!variant) {
      sticky.dataset.mode = 'sold';
      sticky.textContent = soldLabel;
      sticky.disabled = true;
      return;
    }
    sticky.disabled = !variant.available;
    sticky.dataset.mode = variant.available ? 'submit' : 'sold';
    sticky.textContent = variant.available ? stickyLabel : soldLabel;
    stickyPriceText = formatMoney(variant.price);
  }

  function renderVariant(variant, { commit = true } = {}) {
    if (!sizeChosen()) {
      if (idInput) commitVariantId('');
      if (atcBtn) {
        atcBtn.disabled = false;
        atcBtn.dataset.needsSize = 'true';
        atcBtn.textContent = chooseSizeLabel;
      }
      syncStickyLabel(null);
      if (variant) syncGalleryToVariant(variant);
      return;
    }
    if (atcBtn) delete atcBtn.dataset.needsSize;
    if (!variant) {
      if (idInput) commitVariantId('');
      if (atcBtn) {
        atcBtn.disabled = true;
        atcBtn.textContent = soldLabel;
      }
      setMeta(false);
      syncStickyLabel(null);
      return;
    }
    if (commit) commitVariantId(variant.id);
    updatePrice(variant);
    setMeta(variant.available);
    if (atcBtn) {
      atcBtn.disabled = !variant.available;
      atcBtn.textContent = variant.available ? stickyLabel : soldLabel;
    }
    syncStickyLabel(variant);
    syncGalleryToVariant(variant);
  }

  let historyReady = false;

  function commitVariantId(id) {
    if (!idInput) return;
    const next = id ? String(id) : '';
    const prev = String(idInput.value || '');
    idInput.value = next;
    if (historyReady && prev !== next) {
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function getVariantMedia(variant) {
    if (!variant) return null;
    const mapEl = document.getElementById('variant-media-map');
    if (mapEl) {
      try {
        const map = JSON.parse(mapEl.textContent);
        const row = map.find((v) => v.id === variant.id);
        if (row) {
          return {
            ...variant,
            featured_media_id: row.media_id,
            image: row.image,
            featured_media: variant.featured_media || (row.media_id ? { id: row.media_id, preview_image: { src: row.image } } : null),
            featured_image: variant.featured_image || (row.image ? { src: row.image } : null),
          };
        }
      } catch {
        /* ignore */
      }
    }
    return variant;
  }

  function syncGalleryToVariant(variant) {
    const gallery = document.querySelector('[data-pdp-gallery]');
    if (!gallery || !variant) return;
    const colorKey = gallery.dataset.colorOptionKey;
    if (colorKey && selected[colorKey] && gallery.filterByColor) {
      gallery.filterByColor(selected[colorKey], { resetIndex: false });
    }
    if (gallery.showVariant) gallery.showVariant(getVariantMedia(variant));
  }

  function optionValue(variant, index) {
    return [variant.option1, variant.option2, variant.option3][index];
  }

  function findExact(opts) {
    return variants.find((variant) =>
      optionNames.every((name, index) => {
        const key = handleize(name);
        if (!opts[key]) return false;
        return optionValue(variant, index) === opts[key];
      })
    );
  }

  function clearSizeSelection() {
    if (!sizeRow || !sizeKey) return;
    sizeRow.querySelectorAll('[data-option-value]').forEach((btn) => {
      btn.classList.remove('is-selected');
      btn.setAttribute('aria-selected', 'false');
    });
    selected[sizeKey] = '';
    const label = sizeRow.querySelector('[data-option-selected]');
    if (label) label.textContent = '';
  }

  function selectOptionValue(key, value) {
    selected[key] = value || '';
    document.querySelectorAll(`[data-option-key="${key}"]`).forEach((btn) => {
      const on = Boolean(value) && btn.dataset.optionValue === value;
      btn.classList.toggle('is-selected', on);
      btn.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    const label = document.querySelector(`[data-option-selected="${key}"]`);
    if (label) label.textContent = value || '';
  }

  function applySnapshot(snapshot) {
    optionNames.forEach((name) => {
      const key = handleize(name);
      selectOptionValue(key, snapshot[key] || '');
    });
    updateOptionAvailability(selected);
    if (!sizeChosen()) {
      renderVariant(previewVariant(), { commit: false });
      return;
    }
    renderVariant(findExact(selected) || null);
  }

  let silenceHistory = true;

  function selectionSnapshot() {
    const snapshot = {};
    optionNames.forEach((name) => {
      const key = handleize(name);
      snapshot[key] = selected[key] || '';
    });
    return snapshot;
  }

  function syncHistory(variant, previous) {
    if (silenceHistory) return;
    const current = `${window.location.pathname}${window.location.search}${window.location.hash}`;
    if (!window.history.state?.pdp && previous) {
      window.history.replaceState({ pdp: true, selected: previous }, '', current);
    }
    const url = new URL(window.location.href);
    if (variant && variant.id && sizeChosen()) url.searchParams.set('variant', String(variant.id));
    else url.searchParams.delete('variant');
    const next = `${url.pathname}${url.search}${url.hash}`;
    const snapshot = selectionSnapshot();
    if (next === current) {
      window.history.replaceState({ pdp: true, selected: snapshot }, '', next);
      return;
    }
    window.history.pushState({ pdp: true, selected: snapshot }, '', next);
  }

  document.querySelectorAll('[data-option-value]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (btn.disabled) return;
      const key = btn.dataset.optionKey;
      const previous = selectionSnapshot();
      const isSizeClick = Boolean(sizeRow && sizeRow.contains(btn));
      const keptSize = !isSizeClick && sizeKey ? selected[sizeKey] : '';
      selectOptionValue(key, btn.dataset.optionValue);
      if (!isSizeClick && sizeRequired && keptSize) {
        selected[sizeKey] = keptSize;
        const candidate = findExact(selected);
        if (!candidate || !candidate.available) clearSizeSelection();
      }
      updateOptionAvailability(selected);
      if (!sizeChosen()) {
        renderVariant(previewVariant(), { commit: false });
        syncHistory(null, previous);
        return;
      }
      const match = findExact(selected);
      renderVariant(match || null);
      syncHistory(match || null, previous);
    });
  });

  window.addEventListener('popstate', (event) => {
    const snapshot = event.state?.pdp ? event.state.selected : null;
    silenceHistory = true;
    if (snapshot) {
      applySnapshot(snapshot);
    } else {
      const id = new URLSearchParams(window.location.search).get('variant');
      const variant = id ? variants.find((item) => String(item.id) === String(id)) : null;
      if (variant) {
        optionNames.forEach((name, index) => {
          selectOptionValue(handleize(name), optionValue(variant, index) || '');
        });
        updateOptionAvailability(selected);
        renderVariant(variant);
      } else {
        if (sizeRequired) clearSizeSelection();
        updateOptionAvailability(selected);
        renderVariant(previewVariant(), { commit: false });
      }
    }
    silenceHistory = false;
  });

  function previewVariant() {
    return (
      variants.find((v) => optionMatches(v, { ignoreSize: true }) && v.available) ||
      variants.find((v) => optionMatches(v, { ignoreSize: true })) ||
      null
    );
  }

  function optionMatches(variant, { ignoreSize = false } = {}) {
    return optionNames.every((name, i) => {
      const key = handleize(name);
      if (ignoreSize && sizeRow?.querySelector(`[data-option-key="${key}"]`)) return true;
      const val = [variant.option1, variant.option2, variant.option3][i];
      return !selected[key] || val === selected[key];
    });
  }

  form.addEventListener(
    'submit',
    (e) => {
      if (sizeChosen() && idInput?.value) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      focusSizePicker();
    },
    true
  );

  function focusSizePicker() {
    if (!sizeRow) return;
    sizeRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const first = sizeRow.querySelector('[data-option-value]:not(:disabled)');
    first?.focus();
    sizeRow.classList.remove('ar-pdp__options--pulse');
    void sizeRow.offsetWidth;
    sizeRow.classList.add('ar-pdp__options--pulse');
    window.setTimeout(() => sizeRow.classList.remove('ar-pdp__options--pulse'), 1200);
  }
  form.focusSizePicker = focusSizePicker;

  function updateOptionAvailability(current) {
    document.querySelectorAll('[data-option-value]').forEach((btn) => {
      const key = btn.dataset.optionKey;
      const isSizeOption = Boolean(sizeRow && sizeRow.contains(btn));
      const test = { ...current, [key]: btn.dataset.optionValue };
      if (!isSizeOption && sizeKey) delete test[sizeKey];
      const variant = variants.find((item) => {
        const matches = optionNames.every((name, index) => {
          const optionKey = handleize(name);
          if (!test[optionKey]) return true;
          return optionValue(item, index) === test[optionKey];
        });
        return matches && item.available;
      });
      btn.disabled = !variant;
    });
  }

  updateOptionAvailability(selected);
  if (!sizeChosen()) {
    renderVariant(previewVariant(), { commit: false });
  } else {
    const initialVariant = findExact(selected) || findVariant(selected);
    renderVariant(initialVariant || null);
  }
  silenceHistory = false;
  historyReady = true;
}

function initStickyAtc() {
  const bar = document.querySelector('[data-sticky-atc]');
  const form = document.querySelector('[data-pdp-form]');
  if (!bar || !form) return;

  const btn = bar.querySelector('[data-sticky-submit]');
  const atc = form.querySelector('[data-atc-btn]');
  if (!atc) return;

  const io = new IntersectionObserver(([entry]) => {
    bar.classList.toggle('is-visible', !entry.isIntersecting);
  }, { threshold: 0.15 });
  io.observe(atc);

  btn?.addEventListener('click', () => {
    if (btn.dataset.mode === 'choose' || atc.dataset.needsSize === 'true') {
      form.focusSizePicker?.();
      return;
    }
    if (btn.disabled || atc.disabled) return;
    atc.click();
  });
}

function initSizeGuide() {
  const dialog = document.querySelector('[data-size-guide]');
  if (!dialog) return;
  const closeBtn = dialog.querySelector('[data-size-guide-close]');
  let lastFocus = null;

  const open = () => {
    lastFocus = document.activeElement;
    if (typeof dialog.showModal === 'function') dialog.showModal();
    else dialog.setAttribute('open', '');
    closeBtn?.focus();
  };

  const close = () => {
    if (typeof dialog.close === 'function' && dialog.open) dialog.close();
    else dialog.removeAttribute('open');
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
  };

  document.querySelectorAll('[data-size-guide-open]').forEach((btn) => {
    btn.addEventListener('click', open);
  });
  closeBtn?.addEventListener('click', close);
  dialog.addEventListener('click', (e) => {
    if (e.target === dialog) close();
  });
  dialog.addEventListener('cancel', (e) => {
    e.preventDefault();
    close();
  });
}

function initPredictiveSearch() {
  const root = document.querySelector('[data-predict]');
  if (!root) return;
  const input = root.querySelector('[data-predict-input]');
  const results = root.querySelector('[data-predict-results]');
  const openBtn = root.querySelector('[data-predict-open]');
  const panel = root.querySelector('[data-predict-panel]');
  const closeBtn = root.querySelector('[data-predict-close]');
  if (!input || !results || !panel) return;

  let timer;
  const close = () => {
    panel.hidden = true;
    openBtn?.setAttribute('aria-expanded', 'false');
    results.innerHTML = '';
  };
  const open = () => {
    panel.hidden = false;
    openBtn?.setAttribute('aria-expanded', 'true');
    input.focus();
  };

  openBtn?.addEventListener('click', () => {
    if (panel.hidden) open();
    else close();
  });
  closeBtn?.addEventListener('click', close);
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !panel.hidden) close();
  });

  input.addEventListener('input', () => {
    clearTimeout(timer);
    const q = input.value.trim();
    if (q.length < 2) {
      results.innerHTML = '';
      return;
    }
    timer = setTimeout(async () => {
      try {
        const url = `/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last&resources[options][fields]=title,product_type,variants.title,vendor,tag`;
        const res = await fetch(url, { headers: { Accept: 'application/json' } });
        if (!res.ok) return;
        const data = await res.json();
        const products = data?.resources?.results?.products || [];
        if (!products.length) {
          results.innerHTML = `<p class="ar-predict__empty">${root.dataset.empty || 'Nessun risultato'}</p>`;
          return;
        }
        results.innerHTML = products
          .map((p) => {
            const img = p.image ? `<img src="${p.image}" alt="" width="64" height="80" loading="lazy">` : '';
            const vendor = p.vendor ? `<span>${escapeHtml(p.vendor)}</span>` : '';
            return `<a class="ar-predict__item" href="${p.url}">${img}<span><strong>${escapeHtml(p.title)}</strong>${vendor}</span></a>`;
          })
          .join('');
      } catch {
        /* ignore */
      }
    }, 220);
  });
}

function escapeHtml(value) {
  return String(value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function initAjaxCart() {
  document.querySelectorAll('[data-ajax-cart]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      if (btn) btn.disabled = true;
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form) });
        if (!res.ok) throw new Error('fail');
        await refreshCart();
        document.querySelector('[data-cart-drawer]')?.classList.add('is-open');
        document.body.classList.add('cart-open');
      } catch {
        form.submit();
      } finally {
        if (btn) btn.disabled = false;
      }
    });
  });

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    const key = btn.dataset.cartRemove;
    if (!key || btn.disabled) return;
    btn.disabled = true;
    try {
      const res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      if (!res.ok) throw new Error('fail');
      await refreshCart();
    } catch {
      window.location.href = '/cart';
    }
  });
}

async function refreshCart() {
  try {
    const [sectionRes, cartRes] = await Promise.all([fetch('/?section_id=cart-drawer'), fetch('/cart.js')]);
    const html = await sectionRes.text();
    const cart = await cartRes.json();
    const items = new DOMParser().parseFromString(html, 'text/html').getElementById('cart-drawer-items');
    const body = document.querySelector('[data-cart-body]');
    if (body && items) body.innerHTML = items.innerHTML;
    document.querySelectorAll('[data-cart-count], [data-header-cart-count]').forEach((el) => {
      el.textContent = cart.item_count;
      el.toggleAttribute('hidden', cart.item_count === 0);
    });
    const total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    document.querySelector('[data-cart-foot]')?.toggleAttribute('hidden', cart.item_count === 0);
    const ship = document.querySelector('[data-shipping-bar]');
    if (ship) {
      const threshold = Number(ship.dataset.threshold || 0);
      const text = ship.querySelector('p');
      const fill = ship.querySelector('.ar-cart__ship-bar span');
      if (threshold > 0 && text) {
        if (cart.total_price >= threshold) {
          text.textContent = ship.dataset.unlocked || '';
        } else {
          const template = ship.dataset.remainingPrefix || '';
          text.textContent = template.replace('__AMOUNT__', formatMoney(threshold - cart.total_price));
        }
      }
      if (threshold > 0 && fill) {
        fill.style.width = `${Math.min(100, Math.round((cart.total_price * 100) / threshold))}%`;
      }
    }
  } catch {
    /* preview */
  }
}

function formatMoney(cents) {
  if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
    return Shopify.formatMoney(cents);
  }
  return new Intl.NumberFormat(document.documentElement.lang || 'it-IT', {
    style: 'currency',
    currency: 'EUR',
  }).format(cents / 100);
}
